var React = require('react');

function ConsultantsActive (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.5 8C13.5 10.7614 11.2614 13 8.5 13C5.73858 13 3.5 10.7614 3.5 8C3.5 5.23858 5.73858 3 8.5 3C11.2614 3 13.5 5.23858 13.5 8ZM17.277 20C16.834 18.0479 15.7565 16.3368 14.2728 15.0951C14.649 15.0325 15.0352 15 15.4291 15C18.6001 15 21.2787 17.1085 22.1392 20H17.277ZM15.5 8C15.5 9.80473 14.817 11.4499 13.6955 12.6913C14.2356 12.8909 14.8196 13 15.4291 13C18.1905 13 20.4291 10.7614 20.4291 8C20.4291 5.23858 18.1905 3 15.4291 3C14.8196 3 14.2356 3.10906 13.6955 3.30873C14.817 4.55006 15.5 6.19527 15.5 8ZM15.4291 21H1.57089C2.05612 17.6077 4.97353 15 8.5 15C12.0265 15 14.9439 17.6077 15.4291 21Z","fill":"var(--palette-primary)"}));
}

ConsultantsActive.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ConsultantsActive;

ConsultantsActive.default = ConsultantsActive;
